'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var KEYBOARD_MENU_NAVIGATION = (function () {
    var callee = 'KEYBOARD_MENU_NAVIGATION';
    var defaultMenuClass = '.pt-menu-contain';
    var log = function (s) {
        console.log("[".concat(callee, "]: ").concat(s));
    };
    var makeSubMenuBlock = function (subMenu) {
        subMenu.style.cssText = "    display: block;\n" +
            "    background: var(--white-color);\n" +
            "    position: absolute;\n" +
            "    top: 100%;\n" +
            "    left: 0;\n" +
            "    padding-left: 0;\n" +
            "    display: block;\n" +
            "    width: 210px;\n" +
            "    z-index: 999;\n" +
            "    -webkit-box-shadow: 0px 5px 15px 0px rgba(0, 33, 85, 0.1);\n" +
            "    -moz-box-shadow: 0px 5px 15px 0px rgba(0, 33, 85, 0.1);\n" +
            "    box-shadow: 0px 5px 15px 0px rgba(0, 33, 85, 0.1);";
    };
    var makeSubMenuHidden = function (subMenu) {
        subMenu.style.cssText = "";
    };
    var resetOther = function (div) {
        __spreadArray([], __read(div.parentElement.parentElement.querySelectorAll('.menu-item.menu-item-has-children')), false).forEach(function (subMenu) {
            if (!div.isEqualNode(subMenu.querySelector('a'))) {
                makeSubMenuHidden(subMenu.querySelector('.sub-menu'));
                subMenu.classList.remove('aria-menu-expanded');
            }
        });
    };
    var handleKey = function (e) {
        var key = e.code || e.key;
        e.stopPropagation();
        log(key);
        if (['Tab'].includes(key)) {
            resetOther(e.target);
        }
        if (['ArrowDown', 'ArrowRight', 'Space'].includes(key)) {
            resetOther(e.target);
            makeSubMenuBlock(e.target.parentElement.querySelector('.sub-menu'));
            e.target.parentElement.querySelector('.sub-menu').classList.add('aria-menu-expanded');
        }
        if (['ArrowUp', 'ArrowLeft', 'Escape'].includes(key)) {
            makeSubMenuHidden(e.target.parentElement.querySelector('.sub-menu'));
            e.target.parentElement.querySelector('.sub-menu').classList.remove('aria-menu-expanded');
        }
        try {
            registerChildrenEvents(e.target);
        }
        catch (e2) {
            log(JSON.stringify(e2));
        }
    };
    var registerChildrenEvents = function (menu) {
        var subMenu = menu.querySelector('.sub-menu');
        if (!subMenu) {
            return;
        }
        else {
            __spreadArray([], __read(subMenu.querySelectorAll('.menu-item')), false).forEach(function (subMenu) {
                subMenu.addEventListener('keydown', handleKey);
            });
        }
    };
    var init = function (overrideMenuClass) {
        if (overrideMenuClass === void 0) { overrideMenuClass = defaultMenuClass; }
        var menuEl = document.querySelector(overrideMenuClass);
        if (!menuEl) {
            log("".concat(defaultMenuClass, " not found"));
            return;
        }
        else {
            log("Menu element found");
        }
        var rootMenuEls = menuEl.querySelectorAll('.menu-item');
        if (!rootMenuEls) {
            log("Menu does not contain any elements");
            return;
        }
        __spreadArray([], __read(rootMenuEls), false).forEach(function (menuItem) {
            var link = menuItem.querySelector('a');
            link.addEventListener('keydown', handleKey);
        });
    };
    return {
        'init': init
    };
})();
export { KEYBOARD_MENU_NAVIGATION };
//# sourceMappingURL=data:application/json;base64,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